// extracted by mini-css-extract-plugin
export var bannerSection = "banner-section-module--banner-section--vTl18";
export var section = "banner-section-module--section--hSaCg";
export var sliderArrows = "banner-section-module--slider-arrows--fpwmF";
export var sliderDots = "banner-section-module--slider-dots--Rkinf";
export var sliderDotsContainer = "banner-section-module--slider-dots-container--glXEh";